module.exports = __webpack_public_path__ + "img/img13.0afafe1d.jpg";